import { SUBSCRIPTION_BILLING_PERIOD } from "../constants";
import { IPlanData } from "../types";

export function getCryptoPaymentLink(plan: IPlanData) {
  const isAnnual = plan?.period === SUBSCRIPTION_BILLING_PERIOD.ANNUAL;
  const currency = plan?.currency;
  const price = plan?.price;
  const period = plan?.period;
  const planName = plan?.name;
  const shouldAddPeriodName = Boolean(planName && period) && !isAnnual;
  const capitalizedPeriodName = period ? `${period[0]?.toUpperCase()}${period.slice(1)}` : "";
  const planLabel = `${planName}${shouldAddPeriodName ? ` ${capitalizedPeriodName}` : ""}`;
  const planAndPeriod = planLabel.split(" ").join("+");

  const url = `https://www.coinpayments.net/index.php?cmd=_pay&reset=1&merchant=8fb65da0213ae0d779298eaa59f39d6f&item_name=${planAndPeriod}&currency=${currency}&amountf=${price}&quantity=1&allow_quantity=0&want_shipping=0&allow_extra=0&`;
  return url;
}
